import { render, staticRenderFns } from "./ObjectCardTriggerButtons.vue?vue&type=template&id=2d6c023e&scoped=true&"
import script from "./ObjectCardTriggerButtons.vue?vue&type=script&lang=js&"
export * from "./ObjectCardTriggerButtons.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardTriggerButtons.vue?vue&type=style&index=0&id=2d6c023e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c023e",
  null
  
)

export default component.exports